import Vue from 'vue';

class AlertEventBus {
  constructor() {
    this.eventBus = new Vue()
  }
  error(msg) {
    this.eventBus.$emit('alert', {msg: msg, type: 'error', color: 'red'})
  }
  success(msg) {
    this.eventBus.$emit('alert', {msg: msg, type: 'success', color: 'green'})
  }
  info(msg) {
    this.eventBus.$emit('alert', {msg: msg, type: 'info', color: 'blue'})
  }
  warning(msg) {
    this.eventBus.$emit('alert', {msg: msg, type: 'warning', color: 'orange'})
  }
}

export const alertEventBus = new AlertEventBus();
